import React, {useContext, useEffect, useRef, useState} from 'react';
import {createPoolItems, getItemsCurrentPoll, getPoolsCurrentUser, updatePool} from "../../http/poolAPI";
import {Context} from "../../index";
import {Button, Image} from "react-bootstrap";
import { observer } from 'mobx-react-lite';
import {ADD_FUNDS_TO_USD_BALANCE_ROUTE} from "../../utils/consts";
import {useNavigate} from "react-router-dom";
import {FaSearch, FaTimes} from "react-icons/fa";
import {FaCheck, FaPersonRunning} from "react-icons/fa6";
import {toast} from "react-toastify";
import {check} from "../../http/userAPI";
import {addUserFinLog} from "../../http/userLogAPI";
import PoolWinnerPieChart from "./PoolWinnerPieChart";

import PoolPDFExport from "../../components/poolpages/PoolPDFExport";
import PollsPhotoZoom from "../modals/polls/PollsPhotoZoom";
import ChangeAmzName from "../modals/assign/ChangeAmzName";

const PoolFull = ({}) => {
        const { user, poolStore } = useContext(Context);
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [expandedStates, setExpandedStates] = React.useState({});
    const [poolRespondentsQuantity, setPoolRespondentsQuantity] = useState(5);
    const [poolRespondentsQuantityForBuy, setPoolRespondentsQuantityForBuy] = useState(5);
    const [poolRespondentsQuantityForBuyPrice, setPoolRespondentsQuantityForBuyPrice] = useState(0);
    const [poolTimeToAnswer, setPoolTimeToAnswer] = useState(180);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const poolExportRef = useRef(null);
    const poolImagesRef = useRef(null);
    const [showZoom, setShowZoom] = useState(false);
    const [zoomedImage, setZoomedImage] = useState(null);
    const hasUsedOneTimeFreePoll = Boolean(poolStore?.selectedPool?.hasUsedOneTimeFreePoll);
    const freePollAvailable = !hasUsedOneTimeFreePoll && Number(poolStore?.selectedPool?.freeItemsLeftForLast30Days || 0) > 0;
    const isPaidLaunchSelected = Number(poolRespondentsQuantityForBuyPrice || 0) > 0;


    const [showConfirm, setShowConfirm] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [showConfirmPaidRun, setShowConfirmPaidRun] = useState(false);
    const [showConfirmRun, setShowConfirmRun] = useState(false);
    const [inputValuePaidRun, setInputValuePaidRun] = useState("");
    const [inputValueRun, setInputValueRun] = useState("");

    const handleRunClick = () => {
        if (poolStore.poolitemsForThisPool.length === 0) {
            setShowConfirmRun(!showConfirmRun);
        }
    };
    const handlePaidRunClick = () => {
        if (poolStore.poolitemsForThisPool.length === 0) {
            setShowConfirmPaidRun(!showConfirmPaidRun);
        }
    };

    const confirmRun = () => {
        if (inputValueRun.trim().toUpperCase() === "RUN") {
            runPoll();
            setShowConfirmRun(false);
            setInputValueRun("");
        } else {
            alert("Please type 'RUN' to confirm launching the survey.");
        }
    };

    const confirmPaidRun = () => {
        if (inputValuePaidRun.trim().toUpperCase() === "RUN") {
            runPoll();
            setShowConfirmPaidRun(false);
            setInputValuePaidRun("");
        } else {
            alert("Please type 'RUN' to confirm launching the survey.");
        }
    };

    const handleDeleteClick = () => {
        setShowConfirm(!showConfirm);
    };

    const confirmDelete = () => {
        if (inputValue === "DELETE") {
           deleteThisPoll();
            setShowConfirm(false);
            setInputValue("");
        } else {
            alert("Enter 'DELETE' for confirmation");
        }
    };

    const handleToggleDescription = (num) => {
        setExpandedStates((prevState) => ({
            ...prevState,
            [num]: !prevState[num], // Переключаем состояние (открыто/закрыто) для конкретного элемента
        }));
    };

    const activeFlags = [1, 2, 3, 4, 5, 6, 7, 8].filter(
        (num) => poolStore?.selectedPool?.[`pool_item${num}_flag`]
    );

    const getColClass = () => {
        const count = activeFlags.length;
        if (count <= 2) return 'col-3';
        if (count === 3) return 'col-3';
        return 'col-3'; // 4 и больше
    };

    useEffect(() => {
        if (poolStore?.selectedPool?.id) {
            getItemsCurrentPoll(poolStore.selectedPool.id)
                .then((data) => {
                    poolStore.setPoolItemsForThisPool(data);
                })
                .catch((error) => {
                    console.error('Error fetching items:', error);
                });
        }
    }, [poolStore?.selectedPool?.id]);

      const getpool = () => {
        if (user?.user?.id) {
            getPoolsCurrentUser(user.user.id)
                .then((data) => {
                    poolStore.setCurrentUserPools(data);

                    // Находим максимальный id в полученных пулах
                    const maxId = data.reduce((max, item) => {
                        const itemId = Number(item.id);
                        return itemId > max ? itemId : max;
                    }, 0);

                    // Ищем сам пул с этим максимальным id
                    const selectedPool = data.find(item => Number(item.id) === maxId);

                    // Устанавливаем его в стор
                    if (selectedPool) {
                        poolStore.setSelectedPool(selectedPool);
                    }
                })
                .catch((err) => console.error("❌ Error:", err));
        }
    };

    const getItems = () => {
        if (user?.user?.id) {
            getItemsCurrentPoll(poolStore?.selectedPool?.id)
                .then((data) => {
                    poolStore.setPoolItemsForThisPool(data);

                    getPoolsCurrentUser(user.user.id)
                        .then((data) => {
                            poolStore.setCurrentUserPools(data);
                        })
                        .catch((error) => {
                            // Обрабатываем ошибку при получении данных о пулах
                            console.error('Error fetching user pools:', error);
                        });
                })
                .catch((error) => {
                    // Обрабатываем ошибку при получении данных о текущем опросе
                    console.error('Error fetching items:', error);
                });
        } else {
            console.error('User ID is not available');
        }
    };


    const runPoll = async () => {
        setLoading(true);
        if (poolStore?.selectedPool?.id && user?.user?.id && user?.user?.username) {

            if (!isPaidLaunchSelected && hasUsedOneTimeFreePoll) {
                toast.error("Your one-time free poll has already been used.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setLoading(false);
                return;
            }
            if (!isPaidLaunchSelected && Number(poolRespondentsQuantity) !== 5) {
                toast.error("Free poll is available only for 5 respondents.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setLoading(false);
                return;
            }
            if (!poolRespondentsQuantity) {
                toast.error("Set Respondents Quantity", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setLoading(false);
                return
            }
            if (!poolTimeToAnswer) {
                toast.error("Set Time to Answer", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setLoading(false);
                return
            }
            const updatedPoolId = poolStore?.selectedPool?.id;
            // Формируем данные для отправки
            const poolItemsData = {
                userId: user?.user?.id,
                poolId: poolStore?.selectedPool?.id,
                ownerName: user?.user?.username,
                time_to_answer: poolTimeToAnswer,
                itemCount: poolRespondentsQuantity,
                launchMode: isPaidLaunchSelected ? "PAID" : "FREE",
                paidPrice: isPaidLaunchSelected ? poolRespondentsQuantityForBuyPrice : 0,
            };

            try {
                // Отправляем данные на сервер
                const response = await createPoolItems(poolItemsData);
             //   console.log('Poll created successfully:', response);

               getItems();
                await updateThisPoll();
                if (isPaidLaunchSelected) {
                  await refreshUserAfterPaidPoll();
                }

                toast.success("Poll Run Successfully", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setTimeout(() => {
                    if (user?.user?.id) {
                        getPoolsCurrentUser(user.user.id)
                            .then((data) => {
                                poolStore.setCurrentUserPools(data);

                               // Ищем сам пул с этим updatedPoolId
                                const selectedPool = data.find(item => Number(item.id) === Number(updatedPoolId));

                                // Устанавливаем его в стор
                                if (selectedPool) {
                                    poolStore.setSelectedPool(selectedPool);
                                }
                            })
                            .catch((err) => console.error("❌ Error:", err));
                    }
                }, 1000);
                clearData();

            } catch (error) {
                console.error('Error creating poll:', error);
                toast.error(error?.response?.data?.message || "Error launching poll.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                // Обработка ошибки
            }
        } else {
            console.error('Missing required data');
        }
        setLoading(false);
    };

    const updateThisPoll = async () => {
        setLoading(true);
        // Формируем данные для отправки
        const updatedPoolData = {
            status: 'RUNNING',
            userId: user?.user?.id,
            pollId: poolStore?.selectedPool?.id,
            pool_price: poolRespondentsQuantityForBuyPrice || 0,
        };
        try {
            // Отправляем данные на сервер
            const response = await updatePool(updatedPoolData);
            console.log('Poll update successfully:', response);
            // Дополнительные действия после успешной отправки (например, очистка состояния или редирект)

        } catch (error) {
            console.error('Error creating poll:', error);
            // Обработка ошибки
        }
        setLoading(false);
    };

    const refreshUserAfterPaidPoll = async () => {
        setLoading(true);
        // Формируем данные для отправки
        const updatedUserData = {
          id: Number(user?.user?.id),
          amount: Number(poolRespondentsQuantityForBuyPrice),
        };

        try {
            const data = await check();
            user.setUser(data);

            await addUserFinLog(user?.user?.id, user?.user?.id, user?.user?.username, user?.user?.amz_name,
                -poolRespondentsQuantityForBuyPrice,
                -poolRespondentsQuantityForBuyPrice,
                `Charged for paid poll with ${poolRespondentsQuantityForBuy} respondents`,
                "Paid Poll",
                user?.user?.referrer_id             )

            toast.info(`Charged $${poolRespondentsQuantityForBuyPrice} from your balance.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

        } catch (error) {
            console.error('Error creating poll:', error);
            // Обработка ошибки
        }
        setLoading(false);
    }

    const deleteThisPoll = async () => {
        setLoading(true);
        // Формируем данные для отправки
        const updatedPoolData = {
            userId: '31',
            pollId: poolStore?.selectedPool?.id,
            status: 'DELETED',
        };
        try {
            // Отправляем данные на сервер
            const response = await updatePool(updatedPoolData);

            // Дополнительные действия после успешной отправки (например, очистка состояния или редирект)
            getPoolsCurrentUser(user.user.id)
                .then((data) => {
                    poolStore.setCurrentUserPools(data);
                })
                .catch((error) => {
                    // Обрабатываем ошибку при получении данных о пулах
                    console.error('Error fetching user pools:', error);
                });
            toast.success(response.message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            user?.setActiveComponent("AllPolls")
            clearData();
        } catch (error) {
            console.error('Error creating poll:', error);
            // Обработка ошибки
        }
        setLoading(false);

    };

const clearData = () => {
    setPoolRespondentsQuantity(null);
    setPoolRespondentsQuantityForBuy(null);
    setPoolRespondentsQuantityForBuyPrice(0);
    setPoolTimeToAnswer(null);
    setShowConfirm(false);
    setInputValue("");
    setShowConfirmPaidRun(false);
    setInputValuePaidRun("");
    setShowConfirmRun(false);
    setInputValueRun("");
    }


    const getPollType = (type) => {
        switch (type) {
            case 'TITLE_POLL':
                return 'Poll about the Title and Author';
            case 'COVER_POLL':
                return 'Poll about the Book Cover';
            case 'COVER_TITLE_POLL':
                return 'Poll about the Book Cover, Title, and Author';
            case 'MIXED_POLL':
                return 'Poll about the Book Cover, Title, Author, and Description';
            case 'DESCRIPTION_POLL':
                return 'Poll about the Book Description';
            default:
                return 'No survey type available';
        }
    };

    const itemQuantity = [
        { id: 1, name: 'Run Poll on 5 Respondents', quantity: 5 },
    ];

    const timeToPoll = [
        { id: 1, name: '3 H', timeMin: 180 },
        { id: 2, name: '6 H', timeMin: 360 },
        { id: 3, name: '12 H', timeMin: 720 },
        { id: 4, name: '24 H', timeMin: 1440 },
    ];

    const itemQuantityToBuy = [
        { id: 1, name: 'Run Poll on 20 Respondents', quantity: 20, price: 15, one: 0.75 },
        { id: 2, name: 'Run Poll on 30 Respondents', quantity: 30, price: 20, one: 0.67 },
        { id: 3, name: 'Run Poll on 40 Respondents', quantity: 40, price: 25, one: 0.63 },
        { id: 4, name: 'Run Poll on 50 Respondents', quantity: 50, price: 30, one: 0.6 },
        { id: 5, name: 'Run Poll on 75 Respondents', quantity: 75, price: 40, one: 0.53},
        { id: 6, name: 'Run Poll on 100 Respondents', quantity: 100, price: 50, one: 0.5 },
    ];


    return (
        <>
            <div className="card text-center align-content-center shadow-sm mt-2 mb-0 p-3" style={{ width: '100%' }}>
                <div className="p-0 text-start">
                    <h5 className="text-muted fst-italic mb-2" style={{ lineHeight: '1.4', fontSize: '1.2rem' }}>
                        Your Poll Named: <strong>{poolStore?.selectedPool?.name}</strong>
                        <br className="d-md-none" />
                        {poolStore?.poolitemsForThisPool.length === 0
                            ? ' (State: Ready to Run)'
                            : poolStore.selectedPool?.status === 'RUNNING'
                                ? ' (State: Running)'
                                : ' (State: Completed)'}
                    </h5>

                    <h6 className="text-muted fst-italic mb-2" style={{ lineHeight: '1.5', fontSize: '0.95rem' }}>
                        <div className="d-flex flex-column flex-md-row flex-wrap gap-1 text-start">
                            <div>Poll type: <strong>{getPollType(poolStore?.selectedPool?.pool_type)}</strong></div>
                            <div className="d-none d-md-inline"> / </div>
                            <div>Language: <strong>{poolStore?.selectedPool?.language || 'No language available.'}</strong></div>
                            <div className="d-none d-md-inline"> / </div>
                            <div>
                                Created by: <strong>{poolStore?.selectedPool?.owner || 'No owner available.'}</strong>
                                <span> at {
                                    poolStore?.selectedPool?.createdAt
                                        ? new Date(poolStore.selectedPool.createdAt).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: false,
                                        })
                                        : 'No creation date available.'
                                }</span>
                            </div>
                        </div>
                    </h6>

                    <div className="text-muted fst-italic mb-2 text-start" style={{ fontSize: '0.95rem', lineHeight: '1.5' }}>
                        Poll Question to Respondents:
                        <strong> "{poolStore?.selectedPool?.question || 'No question available.'}" </strong>
                    </div>
                </div>

                {poolStore?.poolitemsForThisPool.length === 0 ? (
                    <>
                        <h5 className="mt-0 text-start text-muted fst-italic">
                            Ready to Run? <span className="badge bg-secondary ms-1">Beta</span>
                        </h5>

                        <div
                            className="text-muted small text-start mb-2"
                            style={{
                                lineHeight: '1.5',
                                fontSize: '0.95rem'
                            }}
                        >
                            <strong>Note:</strong> You can run one free poll for <strong>5 respondents</strong> once per account.
                            After that, poll launches are available only as paid launches.

                            <br className="d-md-none" /><br className="d-md-none" />

                            You can create <strong>unlimited polls</strong> on any plan. To launch a poll, choose either your one-time free launch or one of the paid launch options below.
                        </div>
                    </>
                ) : (
                    <>
                        <h5 className="mt-0 text-start text-muted fst-italic">
                            {poolStore.selectedPool?.status === 'RUNNING'
                            ? 'The poll is Running.'
                            : 'The poll is Completed.'} Check the results in the table below.
                        </h5>
                    </>
                )}





                <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch gap-3 mb-3 flex-wrap">

                    {/* Левая часть — настройки */}
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-3 flex-grow-1">

                        {/* Кол-во респондентов */}
                        {freePollAvailable && (
                            <div className="d-flex flex-column small" style={{ minWidth: '220px' }}>
                                <strong className="text-muted mb-1">Set Quantity of Respondents:</strong>
                                <div className="btn-group flex-wrap" role="group">
                                    {itemQuantity.map((q, index) => (
                                        <button
                                            key={q.id}
                                            className={`btn btn-outline-success btn-sm ${poolRespondentsQuantity === q.quantity ? 'active' : ''}`}
                                            onClick={() => setPoolRespondentsQuantity(q.quantity)}
                                            disabled={poolStore.poolitemsForThisPool.length > 0}
                                        >
                                            {q.quantity}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Время на ответ */}
                        <div className="d-flex flex-column small" style={{ minWidth: '220px' }}>
                            <strong className="text-muted mb-1">Set Time to Answer:</strong>
                            <div className="btn-group flex-wrap" role="group">
                                {timeToPoll.map((q, index) => (
                                    <button
                                        key={q.id}
                                        className={`btn btn-outline-success btn-sm ${poolTimeToAnswer === q.timeMin ? 'active' : ''}`}
                                        onClick={() => setPoolTimeToAnswer(q.timeMin)}
                                        disabled={poolStore.poolitemsForThisPool.length > 0}
                                    >
                                        {q.name}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Использование фри-лимита */}
                        {freePollAvailable && (
                        <div className="d-flex flex-column small" style={{ minWidth: '220px' }}>
                            <strong className="text-muted mb-1">Free respondents usage:</strong>
                            <div className="btn-group flex-wrap" role="group">
                                <button className="btn btn-sm btn-outline-success" disabled>
                                    ONE-TIME
                                </button>
                                <button className="btn btn-sm btn-outline-success" disabled>
                                    Used: 0
                                </button>
                                <button className="btn btn-sm btn-outline-success" disabled>
                                    Left: 5
                                </button>
                            </div>
                        </div>
                        )}
                    </div>

                    {/* Правая часть — запуск и удаление */}
                    <div className="d-flex flex-column flex-md-row gap-2 align-self-md-end" style={{ minWidth: '160px' }}>

                        {/* Кнопка запуска */}
                        {freePollAvailable && (
                        <div className="position-relative">
                            <button
                                onClick={handleRunClick}
                                className="btn btn-sm btn-success w-100 w-md-auto"
                                disabled={poolStore.poolitemsForThisPool.length > 0
                                    || !freePollAvailable
                                    || poolRespondentsQuantityForBuyPrice}
                            >
                                <strong>
                                    {poolStore.poolitemsForThisPool.length > 0
                                        ? (poolStore.selectedPool?.status === 'COMPLETED'
                                            ? 'Poll Completed'
                                            : 'Poll Running')
                                        : (Number(poolStore?.selectedPool?.freeItemsLeftForLast30Days) !== 0
                                            ? 'Run Free Poll'
                                            : 'Exceeded')}
                                </strong>
                            </button>
                            {showConfirmRun && (
                                <div className="position-absolute bg-white border p-2 rounded shadow"
                                     style={{ bottom: '42px', right: 0, width: '240px', zIndex: 10 }}>
                                    <p className="small mb-2">After launching the survey, deletion will no longer be possible.</p>
                                    <input
                                        type="text"
                                        value={inputValueRun}
                                        onChange={(e) => setInputValueRun(e.target.value)}
                                        placeholder="Type RUN"
                                        className="form-control mb-2"
                                    />
                                    <div className="d-flex gap-2">
                                        <button onClick={confirmRun} className="btn btn-success btn-sm w-50">Confirm</button>
                                        <button onClick={() => setShowConfirmRun(false)} className="btn btn-outline-success btn-sm w-50">Close</button>
                                    </div>
                                </div>
                            )}
                        </div>
                        )}

                        {/* Кнопка удаления */}
                        <div className="position-relative">
                            <button
                                onClick={handleDeleteClick}
                                disabled={poolStore.poolitemsForThisPool.length > 0}
                                className="btn btn-sm btn-outline-success w-100 w-md-auto"
                            >
                                Delete
                            </button>
                            {showConfirm && (
                                <div className="position-absolute bg-white border p-2 rounded shadow"
                                     style={{ bottom: '42px', right: 0, width: '220px', zIndex: 10 }}>
                                    <input
                                        type="text"
                                        value={inputValue}
                                        onChange={(e) => setInputValue(e.target.value)}
                                        placeholder="Type DELETE"
                                        className="form-control mb-2"
                                    />
                                    <div className="d-flex gap-2">
                                        <button onClick={confirmDelete} className="btn btn-danger btn-sm w-50">Confirm</button>
                                        <button onClick={() => setShowConfirm(false)} className="btn btn-outline-success btn-sm w-50">Close</button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                </div>






                <div className="row gx-3 gy-3 align-items-end mb-3">

                    {/* Левая часть — опции покупки */}
                    <div className="col-12 col-md-9">
                        <div className="d-flex flex-column flex-md-row flex-wrap gap-3 w-100">

                            {/* Количество респондентов */}
                            <div className="d-flex flex-column small flex-grow-1">
                                <span className="text-muted mb-1 text-start "><strong>Set Options for Paid Launch:</strong> Number of respondents / Price. Click again to unselect.</span>
                                <div className="d-flex flex-wrap gap-2">
                                    {itemQuantityToBuy.map((q) => (
                                        <button
                                            key={q.id}
                                            className={`btn btn-outline-success btn-sm ${poolRespondentsQuantityForBuy === q.quantity ? 'active' : ''}`}
                                            onClick={() => {
                                                if (poolRespondentsQuantityForBuy === q.quantity) {
                                                    setPoolRespondentsQuantityForBuy(null);
                                                    setPoolRespondentsQuantityForBuyPrice(0);
                                                    setPoolRespondentsQuantity(5);
                                                } else {
                                                    setPoolRespondentsQuantityForBuy(q.quantity);
                                                    setPoolRespondentsQuantityForBuyPrice(q.price);
                                                    setPoolRespondentsQuantity(q.quantity);
                                                }
                                            }}
                                            disabled={poolStore.poolitemsForThisPool.length > 0}
                                        >
                                            <strong>{q.quantity}</strong> / ${q.price}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Недостаточно средств */}
                            {poolRespondentsQuantityForBuyPrice > user?.user?.lr_balance && (
                                <div className="d-flex flex-column small">
                                    <span className="text-danger mb-1">Not enough funds!</span>
                                    <button
                                        className="btn btn-sm btn-outline-success"
                                        onClick={() => navigate(ADD_FUNDS_TO_USD_BALANCE_ROUTE)}
                                    >
                                        Add Funds to Account
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Правая часть — кнопка запуска */}
                    <div className="col-12 col-md-3">
                        <div className="position-relative w-100">
                            <button
                                onClick={handlePaidRunClick}
                                className="btn btn-sm btn-success w-100"
                                disabled={poolRespondentsQuantityForBuyPrice > user?.user?.lr_balance ||
                                    !poolRespondentsQuantityForBuyPrice ||
                                    poolStore.poolitemsForThisPool.length > 0}
                            >
                                <strong>
                                    {poolStore.poolitemsForThisPool.length > 0
                                        ? (poolStore.selectedPool?.status === 'COMPLETED'
                                            ? 'Poll Completed'
                                            : 'Poll Running')
                                        : (poolRespondentsQuantityForBuyPrice
                                            ? (poolRespondentsQuantityForBuyPrice > user?.user?.lr_balance
                                                ? 'Insufficient'
                                                : `Run Paid Poll for $${poolRespondentsQuantityForBuyPrice}`)
                                            : 'Run Paid Poll (Set Quantity First)')}
                                </strong>
                            </button>

                            {showConfirmPaidRun && (
                                <div
                                    className="position-absolute bg-white border p-2 rounded shadow"
                                    style={{
                                        bottom: '42px',
                                        right: '0',
                                        zIndex: 100,
                                        width: '260px'
                                    }}
                                >
                                    <p className="small mb-2">
                                        Once you launch the survey, it will be published in the Poll Library and can no longer be edited or deleted.<br />
                                        <strong>{poolRespondentsQuantityForBuy}</strong> respondents will be able to join.<br /><br />
                                        Cost: <strong>${poolRespondentsQuantityForBuyPrice}</strong> from your USD balance.
                                        <br /><br />
                                        <strong>Note:</strong> Paid launches do not use your one-time free poll.
                                    </p>
                                    <input
                                        type="text"
                                        value={inputValuePaidRun}
                                        onChange={(e) => setInputValuePaidRun(e.target.value)}
                                        placeholder="Type RUN"
                                        className="form-control mb-2"
                                    />
                                    <div className="d-flex gap-2">
                                        <button onClick={confirmPaidRun} className="btn btn-success btn-sm w-50">Confirm</button>
                                        <button onClick={() => setShowConfirmPaidRun(false)} className="btn btn-outline-success btn-sm w-50">Close</button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>





                <div ref={poolImagesRef}>
                <div className="row g-3">
                    {activeFlags.map((num) => (
                        <div key={num} className="col-12 col-sm-6 col-md-4 col-lg-3">
                            <div className="card shadow-sm p-3 h-100 d-flex flex-column justify-content-start">
                                <p className="mb-2 fw-bold small text-muted text-start">Option #{num}</p>

                                {(poolStore?.selectedPool?.pool_type === 'COVER_POLL' ||
                                    poolStore?.selectedPool?.pool_type === 'MIXED_POLL' ||
                                    poolStore?.selectedPool?.pool_type === 'COVER_TITLE_POLL') && (
                                    <>
                                    <div
                                        onClick={() => {
                                            const imageUrl = poolStore?.selectedPool?.[`pool_item${num}_image`]
                                                ? `${process.env.REACT_APP_API_URL}pools/${poolStore?.selectedPool?.[`pool_item${num}_image`]}`
                                                : `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`;
                                            setZoomedImage(imageUrl);
                                            setShowZoom(true);
                                        }}
                                        style={{ cursor: 'zoom-in' }}
                                    >
                                    <Image
                                        src={
                                            poolStore?.selectedPool?.[`pool_item${num}_image`]
                                                ? `${process.env.REACT_APP_API_URL}pools/${poolStore?.selectedPool?.[`pool_item${num}_image`]}`
                                                : `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`
                                        }
                                        style={{
                                            width: '100%',
                                            maxWidth: '300px',
                                            objectFit: 'cover',
                                            borderRadius: '8px'
                                        }}
                                        className="shadow mb-2 mx-auto d-block"
                                        alt={`Poll Item ${num}`}
                                    />
                                    </div>
                                    </>
                    )}

                                <div className="text-start">
                                    {(poolStore?.selectedPool?.pool_type === 'TITLE_POLL' ||
                                        poolStore?.selectedPool?.pool_type === 'MIXED_POLL' ||
                                        poolStore?.selectedPool?.pool_type === 'COVER_TITLE_POLL') && (
                                        <>
                                            <h6 className="fw-bold text-muted mb-1" style={{ fontSize: '0.85rem' }}>
                                                {poolStore?.selectedPool?.[`pool_item${num}_title`] || 'Untitled'}
                                            </h6>
                                            <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                                by {poolStore?.selectedPool?.[`pool_item${num}_pn`] || 'Unknown Author'} (Author)
                                            </p>
                                        </>
                                    )}

                                    {(poolStore?.selectedPool?.pool_type === 'DESCRIPTION_POLL' ||
                                        poolStore?.selectedPool?.pool_type === 'MIXED_POLL') && (() => {
                                        const description = poolStore?.selectedPool?.[`pool_item${num}_desc`] || 'No description available.';
                                        const isLong = description.length > 190;
                                        const shortDescription = description.slice(0, 190);
                                        const expanded = expandedStates[num] || false;

                                        return (
                                            <div className="text-start mb-0">
                                                <p className="text-secondary small" style={{ lineHeight: '1.4' }}>
                                                    {expanded ? description : shortDescription}
                                                    {isLong && (
                                                        <span
                                                            onClick={() => handleToggleDescription(num)}
                                                            className="text-primary"
                                                            style={{ cursor: 'pointer', marginLeft: '5px' }}
                                                        >
                                            {expanded ? 'Show less' : 'Read more...'}
                                        </span>
                                                    )}
                                                </p>
                                            </div>
                                        );
                                    })()}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                </div>


                {poolStore?.poolitemsForThisPool.length === 0 ? (
                    <h5 className="mt-2 text-start text-muted fst-italic">
                        No survey results yet. Run the survey to see results.
                    </h5>
                ) : (
                    <>
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mt-4">
                            <h5 className="text-start text-muted fst-italic mb-0">
                                {poolStore?.poolitemsForThisPool.length === 0
                                    ? '(State: Ready to Run) '
                                    : poolStore.selectedPool?.status === 'RUNNING'
                                        ? 'Poll is running!'
                                        : 'Poll is Completed!'} Check the results in the pie charts and the table below.
                            </h5>
                            <button
                                onClick={getItems}
                                className="btn btn-sm btn-outline-success"
                            >
                                Refresh Data
                            </button>
                            {poolStore.poolitemsForThisPool.some(item => item.respondent_step === 'STEP2') && (
                            <PoolPDFExport
                                poolRef={poolExportRef}
                                imagesRef={poolImagesRef}
                                activeFlags={activeFlags}
                                poolItems={poolStore.poolitemsForThisPool}
                            />
                                )}
                        </div>
                        <h6 className="text-start text-muted fst-italic mt-2">
                            Click a row in the table to expand and view the feedback for each option.
                        </h6>
                    </>
                )}
                <div ref={poolExportRef}>
                    {poolStore.poolitemsForThisPool.some(item => item.respondent_step === 'STEP2') && (
                        <div className="card text-center align-content-center shadow-sm mt-2 mb-3 p-3" style={{ width: '100%' }}>
                            <div className="p-0">
                                <PoolWinnerPieChart poolItems={poolStore.poolitemsForThisPool} />
                            </div>
                        </div>
                    )}

                </div>

                <div className="table-responsive mb-3" style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '8px' }}>
                    <table className="table table-striped table-sm rounded shadow-sm" style={{ minWidth: '860px', lineHeight: '1.0' }}>
                        <thead className="small bg-success text-light">
                        <tr>
                            <th className="small text-nowrap">ID</th>
                            <th className="small text-nowrap">User</th>
                            <th className="small text-nowrap">Start</th>
                            <th className="small text-nowrap">End</th>
                            <th className="small text-nowrap">Status</th>
                            {activeFlags.map((_, index) => (
                                <th key={index} className="small text-nowrap text-center">
                                    Option #{index + 1}
                                </th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {poolStore.poolitemsForThisPool.map((item, index) => (
                            <React.Fragment key={item.id}>
                                <tr
                                    className="small"
                                    onClick={() => setExpandedRowId(expandedRowId === item.id ? null : item.id)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <td className="text-muted small">{index + 1}</td>
                                    <td className="text-muted small">
                                        {item?.respondent_name ? `${item.respondent_name.slice(0, 3)}***` : <FaSearch className="text-success" />}
                                    </td>
                                    <td className="text-muted small">
                                        {item.start_date
                                            ? new Date(item.start_date * 60000).toLocaleString('en-GB', {
                                                day: '2-digit',
                                                month: 'short',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: false,
                                            })
                                            : <FaTimes className="text-success" />}
                                    </td>
                                    <td className="text-muted small">
                                        {item.end_date
                                            ? new Date(item.end_date * 60000).toLocaleString('en-GB', {
                                                day: '2-digit',
                                                month: 'short',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: false,
                                            })
                                            : <FaTimes className="text-success" />}
                                    </td>
                                    <td className="text-muted small">
                                        {item?.respondent_step === 'STEP0'
                                            ? <FaSearch className="text-success" />
                                            : item?.respondent_step === 'STEP1'
                                                ? <FaPersonRunning className="text-success" />
                                                : item?.respondent_step === 'STEP2'
                                                    ? <FaCheck className="text-success" />
                                                    : 'N/A'}
                                    </td>

                                    {activeFlags.map((_, flagIndex) => {
                                        const ratingKey = `pool_item${flagIndex + 1}_rating`;
                                        const isWinner = Number(item.winner) === flagIndex + 1;
                                        const rating = item[ratingKey] || 0;

                                        return (
                                            <td key={flagIndex} className="px-0 py-0 border text-center align-middle small">
                                                <div className="d-flex justify-content-center align-items-center">
                                                    {[...Array(5)].map((_, starIndex) => {
                                                        const filled = starIndex < rating;
                                                        const color = filled ? (isWinner ? 'red' : 'gold') : 'lightgray';
                                                        return (
                                                            <i
                                                                key={starIndex}
                                                                className={`bi bi-star${filled ? '-fill' : ''}`}
                                                                style={{
                                                                    color,
                                                                    fontSize: '12px',
                                                                    marginRight: '2px',
                                                                }}
                                                            ></i>
                                                        );
                                                    })}
                                                </div>
                                            </td>
                                        );
                                    })}
                                </tr>

                                {expandedRowId === item.id && (
                                    <tr>
                                        <td colSpan={5 + activeFlags.length} className="p-2">
                                            <table className="table table-bordered table-sm m-0"
                                                   style={{ borderCollapse: 'separate', borderSpacing: 0 }}
                                            >
                                                <thead className="small bg-light">
                                                <tr>
                                                    {activeFlags.map((_, index) => {
                                                        const isWinner = Number(item.winner) === index + 1;
                                                        return (
                                                            <th key={index} className={`text-center small ${isWinner ? 'bg-warning border text-muted bg-opacity-10 border-danger' : 'text-muted bg-light'}`}>
                                                                {isWinner ? `🏆 Winner: Option #${index + 1}` : `Option #${index + 1}`}
                                                            </th>
                                                        );
                                                    })}
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    {activeFlags.map((_, index) => {
                                                        const itemText = `pool_item${index + 1}_text`;
                                                        const isWinner = Number(item.winner) === index + 1;
                                                        return (
                                                            <td
                                                                key={index}
                                                                className={`small text-start ${isWinner ? 'bg-secondary bg-opacity-10 border border-danger' : 'text-muted'}`}
                                                                style={{
                                                                    whiteSpace: 'normal',
                                                                    wordBreak: 'break-word',
                                                                    maxWidth: '220px'
                                                                }}
                                                            >
                                                        <span className="small">
                                                            {item[itemText] || 'No survey text yet'}
                                                        </span>
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                        </tbody>
                    </table>
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mt-0">
                    {poolStore.poolitemsForThisPool.some(item => item.respondent_step === 'STEP2') && (
                        <div className="d-none d-md-flex flex-md-row justify-content-between align-items-center w-100">
                            <h5 className="text-start text-muted fst-italic mb-0">
                                {poolStore?.poolitemsForThisPool.length === 0
                                    ? '(State: Ready to Run) '
                                    : poolStore.selectedPool?.status === 'RUNNING'
                                        ? 'Running...'
                                        : 'Completed!'} You Can Download Full Pdf Report, simply tap on the button.
                            </h5>

                            <PoolPDFExport
                                poolRef={poolExportRef}
                                imagesRef={poolImagesRef}
                                activeFlags={activeFlags}
                                poolItems={poolStore.poolitemsForThisPool}
                            />
                        </div>
                    )}
                </div>


            </div>
            <PollsPhotoZoom
            show={showZoom}
            onClose={() => setShowZoom(false)}
            photo={zoomedImage}


            />

</>
    );
};

export default observer(PoolFull);
